import { PageBackgroundData } from 'types/pageTypes';
import { getColorAtCorner } from 'utils/gradient';

/**
 * Get the page colour to use when computing the page number colour
 *
 * @param pageBackground Page background property for page
 * @returns Color of background to use when computing page number colour
 */
const getPageColor = (pageBackgroundData: PageBackgroundData) => {
  const { background: solidColor, gradientBackground: gradient } = pageBackgroundData;

  // Solid color with no defined gradient, just return the colour
  if (solidColor && !gradient) return solidColor;

  // Gradient, return colour at bottom right corner
  return getColorAtCorner(gradient!);
};

export { getPageColor };
